// Query key factory for support messages
export const supportKeys = {
  all: ['support'] as const,

  lists: () => [...supportKeys.all, 'list'] as const,
  list: (filters: Record<string, any> = {}) => [...supportKeys.lists(), filters] as const,

  details: () => [...supportKeys.all, 'detail'] as const,
  detail: (id: string) => [...supportKeys.details(), id] as const,

  userMessages: (userId: string) => [...supportKeys.all, 'user', userId] as const,
  adminMessages: () => [...supportKeys.all, 'admin'] as const,
} as const

export const {
  all: allSupportKey,
  lists: supportListsKey,
  list: supportListKey,
  details: supportDetailsKey,
  detail: supportDetailKey,
  userMessages: userSupportMessagesKey,
  adminMessages: adminSupportMessagesKey,
} = supportKeys
